import React from 'react';

/** Also rendered as static markup in html-templates/index.html before React loads. */
export default function ViewerLoading({ viewport = false }: { viewport?: boolean }) {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: viewport ? '100%' : '100vh',
        width: '100%',
        background: '#090c10',
        color: '#ffffff',
        fontFamily: 'Arial, sans-serif',
        textAlign: 'center',
      }}
    >
      <strong style={{ fontSize: 28, letterSpacing: '0.12em' }}>INGLIS</strong>
      <p style={{ margin: '16px 0', fontSize: 16 }}>
        {viewport ? 'Loading images…' : 'Loading viewer…'}
      </p>
    </div>
  );
}
